import React from 'react'
import "../index.scss"

import Head from "../components/Head"
import Layout from "../components/Layout"
import Faq from "../components/Faq"
import ContactInfos from "../components/ContactInfos"
import ContactForm from "../components/ContactForm"

export default function Contact() {
  return (
    <>
      <Head title="Me contacter | Maxime BOUNAAS-FERRET" />
      <Layout contactCtaDisabled>
        <section id="contact">
          <Faq />
          <div className="grid">
            <ContactForm />
            <ContactInfos />
          </div>
        </section>
      </Layout>
    </>
  )
}